const createMediaView = (_: any) =>
    _.utils.createView({
        name: 'image-preview',
        tag: 'div',
        ignoreRect: true,
        create: ({ root }: any) => {
            let tagName = 'video';

            root.ref.media = document.createElement(tagName);
            root.ref.media.setAttribute('controls', true);
            root.element.style = 'pointer-events: auto;';
            root.element.appendChild(root.ref.media);
        },
        write: _.utils.createRoute({
            DID_MEDIA_PREVIEW_LOAD: ({ root, props }: any) => {
                const { id } = props;

                // get item
                const item = root.query('GET_ITEM', { id });
                if (!item) return;

                let URL = window.URL || window.webkitURL;
                let blob = new Blob([item.file], { type: item.file.type });

                root.ref.media.type = item.file.type;
                root.ref.media.src = (item.file.mock && item.file.url) || URL.createObjectURL(blob);

                // determine dimensions and update panel accordingly
                root.ref.media.addEventListener(
                    'loadeddata',
                    () => {
                        const PREVIEW_HEIGHT = root.query('GET_VIDEO_PREVIEW_HEIGHT');

                        root.dispatch('DID_UPDATE_PANEL_HEIGHT', {
                            id,
                            height: PREVIEW_HEIGHT,
                        });
                    },
                    false,
                );
            },
        }),
    });

export { createMediaView };
